import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
export const LoaderWrapper = styled(Box)(() => `
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    `);
